import {
    DOWNLOAD_COMPARE_EXCEL,
    FETCH_COMPARABLE_PRODUCTS,
} from "./actions.type";
import {
    COMPARE_NO_RESPONSE_ERROR,
    COMPARE_FETCH_START,
    COMPARE_FETCH_END,
    COMPARE_FILE_DOWNLOADED,
} from "./mutations.type";
import { ParametricSearchService } from "../common/api.service";
import { downloadFile, mimeTypes } from "../common/download.service";

export function getInitialState() {
    return {
        comparableProducts: {},
        isCompareFetchingSuccess: false,
        isCompareLoading: false,
        isCompareDownloadSucceed: false,
        powerLabel: "pl1db"
    }
}

const state = getInitialState();

const getters = {
    comparableProducts(state) {
        return state.comparableProducts;
    },
    isCompareLoading(state) {
        return state.isCompareLoading;
    },
    isCompareDownloadSucceed(state) {
        return state.isCompareDownloadSucceed;
    },
    isCompareFetchingSuccess(state) {
        return state.isCompareFetchingSuccess;
    },
    powerLabel(state) {
        return state.powerLabel;
    }
};

const actions = {
    [FETCH_COMPARABLE_PRODUCTS]({commit}, params) {
        commit(COMPARE_FETCH_START);
        return ParametricSearchService.compareProductQuery(params)
            .then(({data}) => {
                commit(COMPARE_FETCH_END, data);
            })
            .catch(error => {
                commit(COMPARE_NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },

    [DOWNLOAD_COMPARE_EXCEL]({commit}, params) {
        commit(COMPARE_FETCH_START);
        return ParametricSearchService.downloadExcel(params)
            .then(function (response) {
                downloadFile(response, mimeTypes.xlsx);
                commit(COMPARE_FILE_DOWNLOADED);
            })
            .catch(error => {
                commit(COMPARE_NO_RESPONSE_ERROR);
                throw new Error(error);
            });
    },
};

const mutations = {
    [COMPARE_FETCH_START](state) {
        state.isCompareLoading = true;
    },
    [COMPARE_FETCH_END](state, data) {
        state.isCompareFetchingSuccess = data.success;
        state.isCompareLoading = false;
        if (state.isCompareFetchingSuccess) {
            state.comparableProducts = data.products;
            state.powerLabel = data.powerLabel;
        }
    },
    [COMPARE_NO_RESPONSE_ERROR]() {
        state.isCompareLoading = false;
        state.isCompareFetchingSuccess = false;
    },
    [COMPARE_FILE_DOWNLOADED]() {
        state.isCompareLoading = false;
        state.isCompareDownloadSucceed = true;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}